import { Link } from 'react-router-dom';
import { BreadcrumbProps, theme } from 'antd';
import { BasicProps } from 'antd/es/layout/layout';
import { TitleProps } from 'antd/es/typography/Title';

export const useGetPageLayout = (type: 'form' | 'landing') => {
  const { token } = theme.useToken();

  const getBreadcrumbProps = (props?: BreadcrumbProps): BreadcrumbProps => ({
    ...props,
    items: [{ title: <Link to="/">Home</Link> }, ...(props?.items ?? [])],
    style: { ...props?.style, margin: '16px 0' },
  });

  const getContentProps = (
    props?: BasicProps & React.RefAttributes<HTMLElement>,
  ): BasicProps & React.RefAttributes<HTMLElement> => ({
    ...props,
    style: {
      ...props?.style,
      background: token.colorBgContainer,
      height: '100%',
      margin: type === 'form' ? 'auto' : 0,
      maxWidth: type === 'form' ? 1200 : undefined,
      minHeight: 0,
      overflow: 'auto',
      padding: 24,
      width: type === 'form' ? '100%' : undefined,
    },
  });

  const getTitleProps = (props?: TitleProps): TitleProps => ({
    ...props,
    level: 3,
    style: { ...props?.style, margin: '0 0 25px' },
  });

  return { getBreadcrumbProps, getContentProps, getTitleProps };
};
